export const columnChartConfig = {
    chart: {
        type: 'column',
    },
    title: {
        text: (null as any)
    },
    credits: {
        enabled: false
    },
    colors: [],
    noData: {
        style: {
            fontWeight: 'bold',
            fontSize: '15px',
            color: 'red'
        }
    },
    xAxis: {
        type: 'linear',
        categories: []
    },
    yAxis: {
        title: {
            text: 'Count',
        }
    },
    series: []
};

export const splineChartConfig = {
    chart: {
        type: 'spline',
    },
    title: {
        text: (null as any)
    },
    credits: {
        enabled: false
    },
    colors: [],
    noData: {
        style: {
            fontWeight: 'bold',
            fontSize: '15px',
            color: 'red'
        }
    },
    xAxis: {
        type: 'linear',
        categories:[]
    },
    yAxis: {
        title: {
            text: 'Count',
        }
    },
    series: []
}
